module.exports = __webpack_public_path__ + "static/img/jianjiePic.b30d9a93.png";